import { borderRadiusSmall, colorBrandBackground, colorNeutralBackground1, colorNeutralForeground1, colorNeutralStroke1, colorStrokeFocus2, curveEasyEase, display, durationFaster, fontFamilyBase, fontSizeBase300, fontWeightSemibold, forcedColorsStylesheetBehavior, lineHeightBase300, strokeWidthThin } from "@fluentui/web-components";
import { sizeHorizontalXXXL, sizeVerticalXXXL } from "@fabric-msft/theme";
import { css } from "@microsoft/fast-element";
// Need to support icon hover styles
export const styles = css `
  ${display("flex")}
  :host {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    align-items: center;
    box-sizing: border-box;
    justify-content: center;
    text-decoration-line: none;
    margin: 0px;
    min-height: ${sizeVerticalXXXL};
    min-width: ${sizeHorizontalXXXL};
    outline-style: none;
    background-color: ${colorNeutralBackground1};
    color: ${colorNeutralForeground1};
    border: ${strokeWidthThin} solid ${colorNeutralStroke1};
    font-size: ${fontSizeBase300};
    font-family: ${fontFamilyBase};
    font-weight: ${fontWeightSemibold};
    line-height: ${lineHeightBase300};
    transition-duration: ${durationFaster};
    transition-property: background, border, color;
    transition-timing-function: ${curveEasyEase};
    cursor: pointer;
  }

  :host([aria-hidden="true"]) {
    display: none;
  }
  :host([aria-expanded="true"])::before {
    content: "";
    z-index: 3;
    position: absolute;
    inset-inline-start: 0;
    height: ${sizeVerticalXXXL};
    width: 3px;
    background: ${colorBrandBackground};
  }

  :host(:focus-visible)::after {
    content: "";
    position: absolute;
    inset: 0px;
    cursor: pointer;
    border-radius: ${borderRadiusSmall};
    outline: none;
    box-shadow: inset 0 0 0 1px ${colorStrokeFocus2};
  }
`.withBehaviors(forcedColorsStylesheetBehavior(css `
    :host(:focus-visible)::after {
      border: 1px solid Highlight !important;
      box-shadow: inset 0 0 0 1px Highlight !important;
    }
  `));
//# sourceMappingURL=multi-view-controller.styles.js.map